module.exports = __webpack_public_path__ + "static/media/04.b47f4b25.jpg";